import React, { createContext, useMemo, useState } from 'react'

export const reloadTableContext = createContext({
  reloadTable: () => {},
  reloadTrigger: {},
  clearTrigger: () => {},
})
const ReloadTableContext = ({ children }) => {
  const [reloadTrigger, setTrigger] = useState()
  const contextValue = useMemo(
    () => ({
      reloadTable: () => setTrigger((ps) => !ps),
      reloadTrigger,
      clearTrigger: () => setTrigger(undefined),
    }),
    [reloadTrigger],
  )
  return (
    <reloadTableContext.Provider value={contextValue}>
      {children}
    </reloadTableContext.Provider>
  )
}

export default ReloadTableContext
